import React from "react"
import { SvgIcon } from "@material-ui/core"

function CrownIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4.5 17.6538H19.5L21.2015 7.94709C21.9346 7.8411 22.5 7.16473 22.5 6.34615C22.5 5.454 21.8284 4.73077 21 4.73077C20.1716 4.73077 19.5 5.454 19.5 6.34615C19.5 6.7238 19.6203 7.07118 19.822 7.34625L14.8082 11.9763L12.75 4.5C13.1965 4.22017 13.5 3.71177 13.5 3.11538C13.5 2.22323 12.8284 1.5 12 1.5C11.1716 1.5 10.5 2.22323 10.5 3.11538C10.5 3.71177 10.8035 4.22017 11.25 4.5L9.19341 11.9702L4.1844 7.3375C4.3822 7.06384 4.5 6.71981 4.5 6.34615C4.5 5.454 3.82843 4.73077 3 4.73077C2.17157 4.73077 1.5 5.454 1.5 6.34615C1.5 7.16942 2.07186 7.84884 2.81114 7.94886L4.5 17.6538Z" />
      <path d="M19.4997 19.2693H4.49973L4.50027 22.5H19.4997V19.2693Z" />
    </SvgIcon>
  )
}

export default CrownIcon
